import classes from './outageErrCard.scss';
import { getLocalizedStrings } from "../../../centralizedLocalizedString";
const OutageErrCard = (props) => {
  let strings=getLocalizedStrings("RepairMaintenanceAlerts");
  let warningImg = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
  
  const formErrorJSX = <div className={[classes.notificationLabel, classes.notificationLabelPadding].join(' ')}>
                        <span>{strings.atleastOnePrefErrMsg}</span>
                      </div>;
  const formResubmitJSX = <div className={classes.group2}>
                      <div className={classes.notificationLabel}>
                      <span>{strings.errorMsg}</span>
                      </div>
                  <div className={classes.somethingWrong}>
                  <a href="javascript:void(0);" id="resubmit" onClick={props.onFormhandler}>{strings.Resubmit}</a>
                  </div>
                  </div>;
  
  let errormsg =  props.turnOnButtonType? formErrorJSX :formResubmitJSX;
  return (
    <div className={classes.errorBanner}>
    <div class="row">
    <div class="col-xs-12">
    <div className={classes.errorMessageContainer}>
        <div className={classes.errorMessage}>
          <p className={classes.errorImage}><img src={warningImg} alt="Warning Image" /></p>
      
            {errormsg}
        
        </div>
        
      </div>
    </div>
    </div>
    <br />
    
    </div>
  );
};

export default OutageErrCard;
